import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const SkeletonBundles = () => {
    return (
        <div className="skeleton-bundles-wrapper xmt-20">
            <div className="container">
                <div className="timer-wrapper d-flex justify-content-between align-items-center">
                    <div className="wrapper br-5 skeleton-loading position-relative">
                        <div className="child br-5 skeleton-loading position-absolute"></div>
                    </div>
                    <div className="more-button"><IconName name="chevron_left" className="icon"/></div>
                </div>
                <div className="border-slider-status skeleton-loading position-relative xmt-4">
                    <div className="show-slider skeleton-loading position-absolute"></div>
                </div>

                <div className="slider-wrapper d-flex align-items-center xmt-6">
                    <div className="slide-box br-12 d-flex justify-content-center align-items-center skeleton-loading position-relative">
                        <div className="price-box d-flex position-absolute">
                            <span className="price skeleton-loading"></span>
                            <span className="discount skeleton-loading"></span>
                        </div>
                        <div className="add-icon">
                            <IconName name="add" className="icon"/>
                        </div>
                        <div className="text position-absolute"></div>
                    </div>
                    <div className="slide-box br-12 xmr-6 d-flex justify-content-center align-items-center skeleton-loading position-relative">
                        <div className="price-box d-flex position-absolute">
                            <span className="price skeleton-loading"></span>
                            <span className="discount skeleton-loading"></span>
                        </div>
                        <div className="add-icon">
                            <IconName name="add" className="icon"/>
                        </div>
                        <div className="text position-absolute"></div>
                    </div>
                    <div className="slide-box br-12 xmr-6 d-flex justify-content-center align-items-center skeleton-loading position-relative">
                        <div className="price-box d-flex position-absolute">
                            <span className="price skeleton-loading"></span>
                            <span className="discount skeleton-loading"></span>
                        </div>
                        <div className="add-icon">
                            <IconName name="add" className="icon"/>
                        </div>
                        <div className="text position-absolute"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonBundles;
